export default __webpack_public_path__ + "static/media/photo6.7935a996.jpg";